<template>
  <div
    v-show="visible"
    class="back-to-top-wrap"
    :style="wrapStyle"
    @click="scrollToTop"
  >
    <slot>
      <button type="button" class="btn btn-info btn-to-top" @click="scrollToTop">
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'BackToTop',
  props: {
    visibleoffset: {
      type: [String, Number],
      default: 300
    },
    bottom: {
      type: String,
      default: '50px'
    },
    right: {
      type: String,
      default: '50px'
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    offset () {
      const value = Number(this.visibleoffset)
      return Number.isFinite(value) ? value : 300
    },
    wrapStyle () {
      return {
        bottom: this.bottom,
        right: this.right
      }
    }
  },
  mounted () {
    this.onScroll = this.onScroll.bind(this)
    document.addEventListener('scroll', this.onScroll, true)
    window.addEventListener('resize', this.onScroll)
    this.$nextTick(() => this.onScroll())
  },
  unmounted () {
    document.removeEventListener('scroll', this.onScroll, true)
    window.removeEventListener('resize', this.onScroll)
  },
  methods: {
    getScrollTop () {
      let top = window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop
        || 0

      const scrollables = document.querySelectorAll('.vb-content')
      scrollables.forEach((el) => {
        if (el.scrollTop > top) top = el.scrollTop
      })

      return top
    },
    onScroll () {
      this.visible = this.getScrollTop() > this.offset
    },
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      document.querySelectorAll('.vb-content').forEach((el) => {
        el.scrollTo({ top: 0, behavior: 'smooth' })
      })
    }
  }
}
</script>

<style scoped>
.back-to-top-wrap {
  position: fixed;
  z-index: 1000;
}
</style>
